import { apiClient, handleApiError } from "../api";

const budgetService = {
  
 async findBudgetById(idbudget) {
    try {
      var retorno = await apiClient.get("/rel/budget/" + idbudget);

      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },
};

export default budgetService;
